import { render, staticRenderFns } from "./LabelAnnotated.vue?vue&type=template&id=44f35b0e"
import script from "./LabelAnnotated.vue?vue&type=script&lang=js"
export * from "./LabelAnnotated.vue?vue&type=script&lang=js"
import style0 from "./LabelAnnotated.vue?vue&type=style&index=0&id=44f35b0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports